/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const impactHeadlineSchema = z.object({
  avgScheduleSlipDays: z.int(),
  dependenciesAdded: z.int(),
  dependenciesRemoved: z.int(),
  direction: z.enum(['EARLIER', 'LATER', 'UNCHANGED']),
  estimatesChanged: z.int(),
  itemsChanged: z.int(),
  itemsCrossingIntoLaterQuarter: z.int(),
  maxScheduleSlipDays: z.int(),
  netRiskChange: z.int(),
  risksAdded: z.int(),
  risksResolved: z.int(),
  teamsAffected: z.int(),
});
